'use strict';
var nodes = document.querySelectorAll('.population');
var total = 0;
var amount = 0;
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var node = _step.value;
        var nodeContent = node.textContent.replace(/,/g, '');
        var num = Number(nodeContent);
        if (!isNaN(num)) {
            total += num;
            amount++;
        }
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
if (amount > 0) {
    var average = Math.floor(total / amount);
    var fmt = function(n) {
        return new Intl.NumberFormat('en-US').format(Math.round(n));
    };
    document.querySelector('.total-population').textContent = fmt(total);
    document.querySelector('.average-population').textContent = fmt(average);
}

//# sourceMappingURL=js_get_data_DOM.736a463c.js.map
